import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/account/settings/billing")({
  component: RouteComponent,
  head: () => ({ meta: [{ title: "Billing | Lutely" }] }),
});

function RouteComponent() {
  return (
    <div className="bg-white rounded-lg p-8 text-center">
      <h2 className="text-lg font-medium">Billing</h2>
    </div>
  );
}
